import { PawPrint, ArrowRight } from "lucide-react";
import shareCardBg from "@/assets/share-card-bg.png";

interface Props {
  backgroundDataUrl?: string;
}

/**
 * Story 4: Łańcuch pomocy - wizualizacja jak udostępnienie się rozprzestrzenia
 */
export const InstagramStoryShare4 = ({ backgroundDataUrl }: Props) => {
  const bgImage = backgroundDataUrl || shareCardBg;

  return (
    <div
      style={{
        width: "1080px",
        height: "1920px",
        fontFamily: "'Nunito', sans-serif",
        display: "flex",
        flexDirection: "column",
        position: "relative",
        overflow: "hidden",
        backgroundColor: "#1a3a2a",
      }}
    >
      {/* Background image */}
      <img
        src={bgImage}
        alt=""
        draggable={false}
        data-export-bg="true"
        loading="eager"
        decoding="sync"
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          zIndex: 0,
        }}
      />

      {/* Content */}
      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: "200px 80px",
          position: "relative",
          zIndex: 1,
        }}
      >
        {/* Chain visualization */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "24px",
            marginBottom: "80px",
          }}
        >
          <span style={{ fontSize: "72px" }}>👤</span>
          <ArrowRight style={{ width: "48px", height: "48px", color: "#4E8A6E" }} />
          <span style={{ fontSize: "72px" }}>👥</span>
          <ArrowRight style={{ width: "48px", height: "48px", color: "#4E8A6E" }} />
          <span style={{ fontSize: "72px" }}>🏠</span>
        </div>

        {/* Main text */}
        <h1
          style={{
            fontSize: "78px",
            fontWeight: 800,
            color: "#2D5A3D",
            margin: "0 0 32px",
            textAlign: "center",
            lineHeight: 1.2,
          }}
        >
          Jeden klik,
          <br />
          setki oczu
        </h1>

        {/* Subtitle */}
        <p
          style={{
            fontSize: "44px",
            fontWeight: 600,
            color: "#4A7A5E",
            margin: "0 0 64px",
            textAlign: "center",
            lineHeight: 1.5,
          }}
        >
          Twoje udostępnienie może dotrzeć
          <br />
          do kogoś, kto szuka pupila
        </p>

        {/* Highlight box */}
        <div
          style={{
            background: "rgba(78, 138, 110, 0.15)",
            borderRadius: "28px",
            padding: "36px 56px",
            marginBottom: "72px",
          }}
        >
          <p
            style={{
              fontSize: "38px",
              fontWeight: 700,
              color: "#3D6B52",
              margin: 0,
              textAlign: "center",
            }}
          >
            Pomagasz, nawet nie wychodząc z domu 🏡
          </p>
        </div>

        {/* CTA */}
        <p
          style={{
            fontSize: "40px",
            fontWeight: 700,
            color: "#4E8A6E",
            margin: 0,
          }}
        >
          Przesuń i udostępnij →
        </p>
      </div>

      {/* Footer */}
      <div
        style={{
          padding: "0 80px 100px",
          display: "flex",
          justifyContent: "center",
          position: "relative",
          zIndex: 1,
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "14px",
          }}
        >
          <div
            style={{
              background: "#4E8A6E",
              borderRadius: "14px",
              width: "52px",
              height: "52px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <PawPrint style={{ width: "28px", height: "28px", color: "#FFFFFF" }} />
          </div>
          <span style={{ fontSize: "28px", fontWeight: 700, color: "#2D5A3D" }}>
            gdzieschronisko.pl
          </span>
        </div>
      </div>
    </div>
  );
};
